export const FILESAVERJS_MAX_NAME_LENTH = 244;